import * as React from "react";
import * as i from "../../../../contracts";
import * as CMP from "../../components";
import { BaseDict } from "../../dict";
import * as RenderMethods from "../LiveStreamElements";

type LeagueItemProps = {
    league: i.League;
    showCheckbox: boolean;
    toggleSelectedLeague: () => void;
    openLeagueTranspiler(sportId: string, leagueId: string, ev: React.SyntheticEvent, element: EventTarget)
    tooltipMessage: string
    showTooltip: boolean
    selectedLeagueId: string
    dict: BaseDict;
}

/* istanbul ignore next */
export class LeagueItem extends React.Component<LeagueItemProps> {

    renderLiveStreamLabel = RenderMethods.renderLiveStreamLabel;
    renderLiveStreamIcon = RenderMethods.renderLiveStreamIcon;

    render() {
        return (
            <div className="rj-league-list__item-holder" data-uat="div-league-list-item-holder">
                <div className={`rj-league-list__item`} data-uat="div-league-list-item">
                    {this.props.showCheckbox &&
                        <CMP.Checkbox
                            id={`rj-league-list__item-${this.props.league.id}`}
                            leagueId={this.props.league.id}
                            checked={this.props.league.isSelected}
                            sportId={this.props.league.sportId}
                            onChange={this.props.toggleSelectedLeague}
                            tooltipMessage={this.props.tooltipMessage}
                            showTooltip={this.props.showTooltip}
                            selectedLeagueId={this.props.selectedLeagueId}
                        />
                    }
                    <a href={this.props.league.linkUrl}
                        onClick={(e: React.SyntheticEvent) => this.props.openLeagueTranspiler(this.props.league.sportId, this.props.league.id, e, e.target)}
                        className="rj-league-list__item-link" data-uat="a-league-list-item-link">
                        <span className="rj-league-list__item-title" data-uat="span-league-list-item-title">{this.props.league.name}</span>
                        <div className="rj-league-list__live-stream-elements-wrap" data-uat="div-league-list-live-stream-elements-wrap">
                            {this.renderLiveStreamIcon(this.props.league.hasLiveStreaming, this.props.dict.LiveSteaming)}
                            {this.renderLiveStreamLabel(this.props.league.hasLiveEvents, this.props.dict.LiveLabel)}
                        </div>
                    </a>
                </div>
            </div>
        )
    }
}